import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";

const Admission = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Header toggleSidebar={() => setOpen(true)} />
            <Sidebar isOpen={open} close={() => setOpen(false)} />
            <div className="about-hero">
                <div className="about-overlay">
                    <h1>Admission</h1>
                    <Breadcrumb />
                </div>
            </div>
            <div className="container contact-page">

                <div className="vision-card admission-card">

                    <h2 className="admission-title">
                        Admission Process
                    </h2>

                    <p>
                        The official application form which is attached with the prospectus must be 
                        completed and got registered by paying rs 150/- as registration fees, which 
                        is not refundable.
                    </p>

                    <p>
                        However registration will not guarantee in getting a seat 
                        reserved. Admissions, where vacancies exist, are made on the basis of an 
                        entrance examintion. Those children who are registered will be notified of 
                        the date of the examination. The principal reserves thr right to admit a 
                        child into the class that the child is found fit for, after examining the child. 
                        Registration may be closed at any time by the principal. Even after a child is 
                        selected, The admission will be confirmed only after the fee is paid within 
                        the stipulated time and acknowledged. For a child who is attending this school 
                        for the first time, a transfer certificate from the previous school must be 
                        furnished before joining school. The transfer certificate must be countersigned 
                        by the appropriate education authority of the state concerned. Since no change 
                        can be made in the age once this is entered in the admission register a 
                        certified copy of the birth certificate is also to be submitted in case. 
                        The date of birth once entered in the admission register will not be altered 
                        under any circumstances. On withdrawal, a transfer certificate will be issued, 
                        if due notice has been given and all fees have been paid according to the school 
                        rules. The principal reserves the right to admit or reject any application for 
                        admission without assigning any reason. Admission to Nav Jeevan Mission School 
                        is a privilege and not a right. Recommendations for admission from any source 
                        will disqualify a prospective candidate. Parents are, therefore, advised to 
                        approach the principals office personally for admission and not through any 
                        other person. Fees Payment.
                    </p>
                </div>

            </div>

            <Footer />
        </>
    );
};

export default Admission;